"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actions_1 = require("./actions");
const initialState = {
    userProfile: {},
    loading: false,
    error: null,
    isEmailSent: false
};
function putUserProfile(state, action) {
    return {
        ...state,
        userProfile: action.userProfile,
    };
}
function putLogInFailed(state, action) {
    return {
        ...state,
        error: action.payload.error,
    };
}
function putCreateUserFailed(state, action) {
    return {
        ...state,
        error: action.payload.error,
    };
}
function deleteLoginFailedError(state) {
    return {
        ...state,
        error: null,
    };
}
function forgotPasswordFailedError(state, action) {
    return {
        ...state,
        error: action.payload.error,
    };
}
function forgotPasswordEmailSent(state, action) {
    return {
        ...state,
        error: null,
        isEmailSent: action.payload.isEmailSent,
    };
}
function reducer(state = initialState, action) {
    switch (action.type) {
        case actions_1.actions.REQUEST_USER_PROFILE:
            return { ...state, loading: true };
        case actions_1.actions.PUT_USER_PROFILE:
            return putUserProfile(state, action);
        case actions_1.actions.LOG_IN_FAILED:
            return putLogInFailed(state, action);
        case actions_1.actions.CREATE_USER_FAILED:
            return putCreateUserFailed(state, action);
        case actions_1.actions.DELETE_LOGIN_FAILED_ERROR:
            return deleteLoginFailedError(state);
        case actions_1.actions.FORGOT_PASSWORD_SUCCESS:
            return forgotPasswordEmailSent(state, action);
        case actions_1.actions.FORGOT_PASSWORD_FAILED:
            return forgotPasswordFailedError(state, action);
        default: return state;
    }
}
exports.reducer = reducer;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/userProfile/reducer.ts